import styled, { css } from "styled-components";

import { Nav } from "@olist/design-system";

interface IStyledNavProps {
  isActive: boolean;
}

export const StyledNav = styled(Nav)(
  ({ isActive }: IStyledNavProps) => css`
    ${isActive &&
    css`
      color: ${({ theme }) => theme.olist.color.primary.base};
      font-weight: 800;
    `}
  `
);

export const StyledAnchor = StyledNav.withComponent("a");
